import { useQuery } from "@tanstack/react-query";
import PreviewCertificateAPI from "../api/previewCertificate";

export function useUnauthPreviewCertificate(id) {
  const response = useQuery({
    queryKey: ["_unauthPreviewCertificate"],
    queryFn: async () => {
      return await PreviewCertificateAPI.unauthPreviewCertificate(id);
    }
  });

  return response;
}

export function useAuthPreviewCertificate(id) {
  const response = useQuery({
    queryKey: ["_authPreviewCertificate"],
    queryFn: async () => {
      return await PreviewCertificateAPI.authPreviewCertificate(id);
    }
  });

  return response;
}
